import { render, staticRenderFns } from "./OTAActionItem.vue?vue&type=template&id=1d105d68&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./OTAActionItem.vue?vue&type=script&lang=js&"
export * from "./OTAActionItem.vue?vue&type=script&lang=js&"
import style0 from "./OTAActionItem.vue?vue&type=style&index=0&id=1d105d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d105d68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
